module.exports = __webpack_public_path__ + "static/img/int3.6c5424bf.jpg";